module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAATxJREFUeNqM07suREEcx/Ezu8fG5gSFQu0JJBqV2IJC4vIKCs0+gEhoJFiJFxC9RkdsotGoNvEAGtFTKITsLmLHd+Q3TMbacyb5ZM7c/2cuxlq7miRJA5WkWHrHFs5dwTDBHfkOrvCRM3gI8+o/hXbJTYImHtEbMLinPk2NGXWVKazyDJcY+2eCZ63ux1g/gUtldLCu737pU32ysDINGqs4yolgUX2N/ImgXiCCEQ1+y4vABO0+ggV0sRFP0C8Ct+tPwcm4/FXtszj87u/uAcaRoYVbaakuCQzjwP6mhzTYzDZWUApW7AS/4H5xW/fgBqc48xFMRCvFqthDTeUZRVIuMkGKTcyp7PJdVFzZX+XugCu8hklco6aTaOhR/VzLJT2mOL1oX5a10D32w70xOc/5GNM6ugucxB2+BBgAGevjtz9oGyMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/roles_modules/edit_privilage.png
// module id = 963
// module chunks = 438